export default {
  install(Vue){
    Vue.filter('periodTime',(v, format = 'yyyy年MM月dd旬', language, type)=>{
      if (v) {
        const date = new Date(v);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        if (format == "yyyy年M半年") {
          return `${year}年${["上", "下"][month]}半年`;
        } else if (format == "yyyy年第M季度") {
          return `${year}年第${month + 1}季度`;
        }
        return `${year}年${month + 1}月${["上","中", "下"][[1, 11, 21].indexOf(day)]}旬`;
      }
      return '';
    })
  }
}